import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { useShipmentTrackerPermissions } from '../hooks/useShipmentTrackerPermissions';
import { fetchShipmentTrackerBootstrap } from '../store/slices/shipmentTrackerSlice';

interface ShipmentTrackerGuardProps {
  children: React.ReactNode;
}

const ShipmentTrackerGuard: React.FC<ShipmentTrackerGuardProps> = ({ children }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const isDataInitialized = useAppSelector((state) => state.auth.isDataInitialized);
  const { canRead } = useShipmentTrackerPermissions();

  useEffect(() => {
    if (isDataInitialized && canRead) {
      dispatch(fetchShipmentTrackerBootstrap());
    }
  }, [dispatch, isDataInitialized, canRead]);

  if (!isDataInitialized) return null;

  if (!canRead) {
    return (
      <div className="dashboard-empty-state">
        <p className="dashboard-empty-state-text">{t('shipment_tracker_license_required_title')}</p>
        <p className="dashboard-empty-state-hint">{t('shipment_tracker_license_required_description')}</p>
        <Link to="/licenses/buy?plugin=shipment_tracker" className="dashboard-empty-state-btn">
          {t('shipment_tracker_get_license_button')}
        </Link>
      </div>
    );
  }

  return <>{children}</>;
};

export default ShipmentTrackerGuard;
